<div class="card border-0" style="background-color: #b2d0dc" *transloco="let t; read: 'ime.components.dashboard'">
  <div class="card-body">
    <h4 class="card-title pb-3 d-flex justify-content-between">
      <svg viewBox="0 0 8 8" class="icon me-1" [inlineSVG]="'#star'">
      </svg>
      {{t('Favourites')}}
      <help-button *transloco="let h" [key]="h('help.ime.components.dashboard.favourites')"></help-button>
      <a class="ms-auto mb-n2 text-primary" (click)="openAddRow()" title="Add">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
      </a>
    </h4>
    <ul class="list-group list-group-flush">
      <ng-container *ngIf="hasFavourites || externalLinks?.length > 0; else noFavouritesTemplate">
        <li class="list-group-item d-flex justify-content-between" *ngFor="let externalLink of externalLinks">
          <a href="{{externalLink.Value}}">{{externalLink.Text}}</a>
        </li>
        <li class="list-group-item d-flex justify-content-between parent" *ngFor="let favourite of favourites">
          <ng-container [ngTemplateOutlet]="editableFavourite?.Id === favourite.Id ? editTemplate : viewTemplate" [ngTemplateOutletContext]="{favourite: favourite}">
          </ng-container>
          <ng-template #viewTemplate let-favourite="favourite">
            <a href="{{favourite.Value}}">{{favourite.Text}}</a>
            <button type="button" class="btn btn-sm btn-outline-primary show-on-parent-hover my-n1" (click)="openEditRow(favourite)" title="Edit">
              <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#pencil"></svg>
            </button>
          </ng-template>
          <ng-template #editTemplate>
            <div class="flex-column flex-fill">
              <input type="text" class="form-control mb-2" id="name-{{editableFavourite.Id}}" name="name-{{editableFavourite.Id}}" [(ngModel)]="editableFavourite.Text" placeholder="{{t('Name')}}">
              <div class="d-flex">
                <input type="text" class="form-control" [(ngModel)]="editableFavourite.Value" name="url-{{editableFavourite.Id}}" id="url-{{editableFavourite.Id}}" placeholder="https://">
                <div class="btn-group btn-group-sm ms-2" role="group">
                  <button type="button" class="btn btn-sm btn-outline-danger" (click)="delete()" title="Delete">
                    <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#trash'"></svg>
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-warning" (click)="cancel()" title="Cancel">
                    <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#x-mark'"></svg>
                  </button>
                  <button type="button" class="btn btn-sm btn-outline-success" (click)="edit()" title="Save">
                    <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#check'"></svg>
                  </button>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ng-container>
      <ng-template #noFavouritesTemplate>
        <li class="list-group-item d-flex justify-content-between">
          {{t('No favourites')}}
        </li>
      </ng-template>
      <li class="list-group-item d-flex justify-content-between" *ngIf="showAddNew && editableFavourite">
        <div class="flex-column flex-fill">
          <input type="text" class="form-control mb-2" id="addNewName" name="addNewName" [(ngModel)]="editableFavourite.Text" placeholder="{{t('Name')}}">
          <div class="d-flex">
            <input type="text" class="form-control" [(ngModel)]="editableFavourite.Value" name="addNewUrl" id="addNewUrl" placeholder="https://">
            <div class="btn-group btn-group-sm ms-2" role="group">
              <button type="button" class="btn btn-sm btn-outline-warning" (click)="cancel()" title="Cancel">
                <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#x-mark'"></svg>
              </button>
              <button type="button" class="btn btn-sm btn-outline-success" (click)="add()" title="Save">
                <svg viewBox="0 0 8 8" class="icon" [inlineSVG]="'#check'"></svg>
              </button>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</div>
